<script lang="ts" setup>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { nextTick } from 'vue';

gsap.registerPlugin(ScrollTrigger);

const initAni = () => {
  const gTimeLine = gsap.timeline();
  gTimeLine
    .fromTo(
      '.cardBox .card1',
      {
        y: 0,
        opacity: 1
      },
      {
        y: -1500,
        opacity: 1,
        scrollTrigger: {
          trigger: '.cardBox',
          start: 'top',
          end: 'bottom',
          pin: true,
          scrub: true
          // markers: false
        }
      }
    )
    .fromTo(
      '.cardBox .card2',
      {
        y: 0,
        opacity: 1
      },
      {
        y: -300,
        opacity: 0,
        scrollTrigger: {
          trigger: '.cardBox',
          start: 'top -100%',
          end: 'bottom ',
          pin: true,
          scrub: true
          // markers: true
        }
      }
    );
};

const lists = ref([
  {
    image: './images/story/vision.jpg',
    title: 'vision',
    text: '豐富生活的無限想像'
  },
  {
    image: './images/story/mission.jpg',
    title: 'mission',
    text: '我們致力於協助<br>每個熱愛生活的人找生活'
  }
]);
defineExpose({
  initAni
});
// onMounted(() => {
//   // initAni()
//   nextTick(() => {
//     useImagesLoaded('.cardBox img').then(initAni)
//   });
// });
</script>

<template>
  <section class="cardBox">
    <div class="cardBox__inner">
      <div class="card" :class="`card${index + 1}`" v-for="(item, index) in lists" :key="index">
        <figure class="card__pic">
          <Nimg :src="item.image"></Nimg>
        </figure>
        <div class="card__item">
          <div class="card__title">{{ item.title }}</div>
          <div class="card__text" v-html="item.text"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.cardBox {
  position: relative;
  z-index: 1;
  background-color: $color-white-1;
  @include grid;

  &::after {
    content: '';
    position: absolute;
    left: toRem(-50);
    top: 0;
    z-index: -1;
    width: calc(100% + toRem(100));
    height: 100%;
    background-color: $color-white-1;
  }

  &__inner {
    position: relative;
    grid-column: 2 / span 10;
    height: 100vh;
    margin-left: toRem(-34);
    margin-right: toRem(-34);
  }

  .card {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    display: flex;

    @include max-media(960) {
      max-width: 640px;
      flex-direction: column;
    }

    &:nth-child(odd) {
      background-color: $color-black-1;
      color: $color-white-1;
    }

    &:nth-child(even) {
      background-color: $color-white-2;
      color: $color-black-1;

      @include min-media(961) {
        flex-direction: row-reverse;
      }
    }

    &__pic {
      width: 55%;

      @include max-media(960) {
        width: 100%;
      }

      img {
        display: block;
        width: 100%;
      }
    }

    &__item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 45%;
      padding: toRem(20);
      text-align: center;

      @include max-media(960) {
        width: 100%;
        min-height: toRem(260);
        padding: toRem(40) toRem(20);
      }
    }

    &__title {
      font-size: toRem(80);
      font-weight: 500;
      font-family: $font-TextaAlt;
      color: $color-brand-3;

      @include max-media(960) {
        font-size: toRem(48);
        line-height: toRem(38);
        margin-bottom: toRem(15);
      }
    }

    &__text {
      font-size: toRem(20);
      line-height: toRem(28);

      @include max-media(960) {
        font-size: toRem(16);
        line-height: toRem(23);
      }
    }
  }

  .card1 {
    background-color: #faa;
    z-index: 5;
  }

  .card2 {
    background-color: purple;
    z-index: 4;
  }
}
</style>
